<template>
  <div style="width: 100vw;" :class="ISphone ? smallh2label : bigh2label">
    <img
      src="http://pic.midongtech.xyz/yytgw/assets/img_spread_img_banner_thir.jpg"
      style="width: 100vw;height: 20.5vw;margin-top:2px;"
    />

    <!--   选项  -->
    <div class="fx-column fx-row-center" style=" width: 100vw;">
      <div :class="ISphone ? smallh1label : bigh1label" style="margin-top: 5vw;">电商服务</div>

      <div class="blueline"></div>

      <div
        style="margin-top: 2vw;margin-bottom: 4vw; width: 50vw; "
      >“品牌”与“流量”双向结合，拥有丰富的市场全案营销经验，为电商客户提供定制化的广告服务，从而助力成功</div>

      <div
        class="fx-row fx-row-top fx-row-space-around fx-wrap"
        style="width: 90%;  margin-bottom: 3vw;"
      >
        <div
          class="fx-column fx-row-center adservecell"
          style=" margin-top: 2vw; "
          v-for="(item, index) in dataarray1"
          v-bind:key="index"
        >
          <img :src="item.iconurl" style="width: 11.4vw;height: 11.4vw;" />
          <div style="margin-top: 2.8vw; ">{{ item.titlestr }}</div>
          <div style="margin-top: 1.4vw; ">{{ item.desstr }}</div>
        </div>
      </div>
    </div>

    <!--    联系我们  -->

    <contactusview />
  </div>
</template>
<script type="text/ecmascript-6">
import contactusview from "@/components/contactusview.vue";

export default {
  name: "Marketpromotion",
  components: {
    contactusview
  },
  data() {
    return {
      ISphone: false,

      bigh1label: "bigh1label",
      bigh2label: "bigh2label",
      bigh3label: "bigh3label",
      smallh1label: "smallh1label",
      smallh2label: "smallh2label",
      smallh3label: "smallh3label",

      dataarray1: [
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_shop_img_service_fir.png",
          titlestr: "营销策划",
          desstr:
            "以客户为中心，为客户提供多维度全方位的产品分析、策略及方案规划，提升产品推广效果"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_shop_img_service_sec.png",
          titlestr: "创意设计",
          desstr: "提供本地化广告创意、素材制作及优化支持"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_shop_img_service_thir.png",
          titlestr: "媒体运营",
          desstr:
            "目标市场媒介资源覆盖,与头部媒体保持长期深度合作,快速对接与管理,提升ROI"
        },
        {
          iconurl:
            "http://pic.midongtech.xyz/yytgw/assets/img_shop_img_service_four.png",
          titlestr: "行业洞察",
          desstr:
            "基于市场调研及数据支持，深度挖掘目标市场行业形态，准确分析产品竞争力"
        }
      ]
    };
  },
  mounted() {
    this.ISphone = this.$appdata.ISphone;
  },
  methods: {
    /**
     * 点击事件
     */
    /**
     * 网络请求
     */
    /**
     * 业务方法
     */
    /**
     * 回调方法
     */
    /**
     * 页面私有方法
     */
  }
};
</script>
<style lang="less" scoped>
/*页面公共样式*/
.adservecell {
  width: 40vw;
  // height: 25.7vw;
}

/*头部*/

/*列表*/
</style>
